import { useEffect } from 'react';

import { PlayerAPI } from 'bitmovin-player/modules/bitmovinplayer-core';

import { PlayerProps } from 'components/Player/types.ts';

export default (player: PlayerAPI | null, muted: PlayerProps['muted']) => {
    useEffect(() => {
        if (typeof muted === 'boolean' && player) {
            if (muted) {
                player.mute();
            } else {
                player.unmute();
            }
        }
    }, [muted, player]);
};
